/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Basic_SettingsInputs */

const en_admin_resource_form_basic_settings = /** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic Settings`)
};

const de_admin_resource_form_basic_settings = /** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundeinstellungen`)
};

const es_admin_resource_form_basic_settings = /** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración básica`)
};

const fr_admin_resource_form_basic_settings = /** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de base`)
};

const nl_admin_resource_form_basic_settings = /** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basisinstellingen`)
};

/** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */
const it_admin_resource_form_basic_settings = en_admin_resource_form_basic_settings;

/** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_basic_settings = en_admin_resource_form_basic_settings;

/** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */
const pl_admin_resource_form_basic_settings = en_admin_resource_form_basic_settings;

/** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */
const hu_admin_resource_form_basic_settings = en_admin_resource_form_basic_settings;

/** @type {(inputs: Admin_Resource_Form_Basic_SettingsInputs) => LocalizedString} */
const ro_admin_resource_form_basic_settings = en_admin_resource_form_basic_settings;

/**
* | output |
* | --- |
* | "Basic Settings" |
*
* @param {Admin_Resource_Form_Basic_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_basic_settings = /** @type {((inputs?: Admin_Resource_Form_Basic_SettingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Basic_SettingsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_basic_settings(inputs)
	if (locale === "de") return de_admin_resource_form_basic_settings(inputs)
	if (locale === "es") return es_admin_resource_form_basic_settings(inputs)
	if (locale === "fr") return fr_admin_resource_form_basic_settings(inputs)
	if (locale === "nl") return nl_admin_resource_form_basic_settings(inputs)
	if (locale === "it") return it_admin_resource_form_basic_settings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_basic_settings(inputs)
	if (locale === "pl") return pl_admin_resource_form_basic_settings(inputs)
	if (locale === "hu") return hu_admin_resource_form_basic_settings(inputs)
	return ro_admin_resource_form_basic_settings(inputs)
});
export { admin_resource_form_basic_settings as "admin.resource_form.basic_settings" }